import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentLoadOverview } from '../../models/shipment-load.model';
import { ShipmentLoadOverviewLoad, ShipmentLoadOverviewSetInitialState } from './shipment-load-main-info.actions';
import { ShipmentLoadMainInfoState } from './shipment-load-main-info.state';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadMainInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadMainInfoState.getLoaded);
  mainInfo$: Observable<ShipmentLoadOverview> = this.store.select(ShipmentLoadMainInfoState.getOverview);
  isCanceledLabel$: Observable<boolean> = this.store.select(ShipmentLoadMainInfoState.getCanceledStatus);

  constructor(private store: Store) {}

  loadAll(identifier: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadOverviewLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadOverviewSetInitialState());
  }
}
